// Centralized analytics event names to avoid typos and keep naming consistent.
export const PAGE_VIEW = 'page_view'
export const SIGN_IN = 'sign_in'
export const SIGN_OUT = 'sign_out'
export const PURCHASE = 'purchase'
export const DRAFT_SAVE = 'draft_save'
export const INVOICE_SEND = 'invoice_send'

export default {
  PAGE_VIEW,
  SIGN_IN,
  SIGN_OUT,
  PURCHASE,
  DRAFT_SAVE,
  INVOICE_SEND,
}
